import { useDispatch } from 'react-redux'

import { MapSearchButton as View } from 'ui-components'
import { openMapSearch, useIsMapSearchOpen } from '~map-preview/states/ui'

export const MapSearchButton = () => {
  const dispatch = useDispatch()
  const open = useIsMapSearchOpen()

  const handleClick = () => {
    dispatch(openMapSearch())
  }

  return (
    <View
      active={open}
      onClick={handleClick}
    />
  )
}
